<template>
  <div id="galeria" class="container py-4">
    <h2 class="text-center mb-4">Galería de Trabajos</h2>
    <div v-if="cargando">Cargando trabajos...</div>
    <div v-else-if="error">Error: {{ error }}</div>
    <div v-else class="row">
      <div
        v-for="trabajo in trabajos"
        :key="trabajo.id"
        class="col-md-4 mb-4"
      >
        <div class="card h-100 shadow-sm" @click="verTrabajo(trabajo.id)">
          <img v-if="trabajo.coverUrl" :src="resolveUrl(trabajo.coverUrl)" :alt="trabajo.titulo" class="card-img-top" />
          <div class="card-body">
            <h5 class="card-title">{{ trabajo.titulo }}</h5>
            <p class="card-text">{{ trabajo.descripcion }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listarTrabajos } from '@/services/trabajosService'
import api from '@/config/api'

export default {
  name: 'galeria',
  data() {
    return {
      trabajos: [],
      cargando: false,
      error: null,
    };
  },
  async created() {
    try {
      this.cargando = true
      const res = await listarTrabajos()
      this.trabajos = res
    } catch (e) {
      this.error = e.message
    } finally {
      this.cargando = false
    }
  },
  methods: {
    verTrabajo(id) {
      this.$router.push({ path: `/trabajo/${id}` });
    },
    resolveUrl(url) {
      if (!url) return ''
      return url.startsWith('http') ? url : `${api.baseURL}${url}`
    },
  },
};
</script>

<style scoped>
.card-img-top {
  object-fit: cover;
  height: 200px;
}
.card {
  transition: transform 0.3s ease;
  cursor: pointer;
}
.card:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
</style>
